module.exports = __webpack_public_path__ + "img/faqs_border.b9e98039.svg";